export default class AzureRequest {

  constructor(url) {
    this.url = url || 'https://search-bot-orientation.search.windows.net/indexes/formations/docs/search?api-version=2020-06-30-Preview';
  }

  async post(data) {
    const result = await fetch(this.url, {
      method: 'POST',
      headers: {
        'api-key': 'B4383BFBB744F5091648F0871FEC99B9',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    }).then((response) => this.getResponseData(response));
    return result;
  }

  async getResponseData(response) {
    if (!response.ok) {
      response.json().then((data) =>  console.log(data.error.message))
      throw Error(response.statusText);
    }
    return response.json();
  }

}